<template>
  <div class="postcontainer">
    <transition name="swap" mode="out-in">
      <div id="post" v-if="loaded">
        <v-title :title="postTitle" v-if="postTitle"></v-title>
        <h1>{{ activePost.title.S }}</h1>
        <div class="postcontent">
          <div class="featuredImageContainer" v-if="activePost.featuredImage">
            <img :src="activePost.featuredImage.S" id="featuredImage">
          </div>
          <vue-markdown :source="activePost.content.S" :html='true'></vue-markdown>
        </div>
      </div>
    </transition>
    <div id="post" v-if="!loaded">
      <h1>Loading...</h1>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import axios from 'axios'
import vTitle from '../components/v-title';

export default {
  name: 'Post',
  components: {
    VueMarkdown,
    'v-title': vTitle
  },
  data() {
    return {
      activePost: {
        title: {S: ''},
        content: {S: ''}
      },
      postSlug: '',
      loaded: false,
      postTitle: ''
    }
  },
  mounted() {
    console.log('Post Mounted')
    if (!this.$store.state.posts.length) {
      this.getPosts()
    } else {
      this.$store.commit('setActivePost', this.$route.params.id)
      this.postSlug = this.$route.params.id;
      this.activePost = this.$store.state.activePost;
      this.postTitle = "Lexi's Kitchen Blog | " + this.activePost.title.S
      this.loaded = true;
    }
    this.$store.commit('setHeaderClass', '')
  },
  methods: {
    async getPosts() {

      const init = {
        headers: {
          "Content-Type": 'application/json',
          "X-Api-Key": "NhLutvx5gP2646WFTQ8Ds1i8jHqQ0fILaHUZ7hEs",
        }
      }

      const apiurl = 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev/blog/get'

      axios
        .get(apiurl, init)
        .then( response => {
          console.log(response);
          this.$store.commit('addPostData', response.data)
          this.$store.commit('setActivePost', this.$route.params.id)
          this.postSlug = this.$route.params.id
          this.activePost = this.$store.state.activePost
          this.postTitle = "Lexi's Kitchen Blog | " + this.activePost.title.S
          this.loaded = true;
        })
    }
  }
}
</script>

<style scoped lang="scss">

  #blog {
    max-width: 1500px;
    margin: auto;
  }
  .blogcontainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .blogpost {
    margin: 10px;
    padding: 20px;
    background-color: #eaeaea;
  }

  .postcontainer {
    max-width: 760px;
    margin: auto;
  }

  .posttitle {
    border-bottom: 1px solid #b5b5b5;
  }

  #featuredImage {
    max-width: 100%;
  }

  .swap-enter-active {
    transition: opacity .5s;
  }
  .swap-leave-active {
    transition: opacity .3s;
  }
  .swap-enter {
    opacity: 0;
  }
  .swap-leave-to {
    opacity: 0;
  }

  @media (max-width: 900px) {
    .blogpost {
      padding: 15px;
    }
    .blogcontainer {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 700px) {
    .blogcontainer {
      grid-template-columns: 1fr;
    }
  }

</style>
